module.exports = __webpack_public_path__ + "img/trophyStar.d7df05c5.svg";